import React from 'react';
import { Trash2, Tag, Clock, ShoppingCart } from 'lucide-react';

export const ServiceBasket = ({
  services,
  onRemoveService,
  totals,
  className = ''
}) => {
  if (services.length === 0) {
    return (
      <div className={`bg-white rounded-2xl shadow-lg p-6 ${className}`}>
        <h3 className="text-xl font-semibold text-[#2C1810] mb-4 flex items-center gap-2">
          <ShoppingCart className="text-[#C9A96E]" size={24} />
          Votre panier
        </h3>
        <div className="text-center py-8 text-[#5D4037]">
          <ShoppingCart className="mx-auto mb-3 text-[#D4C4B5]" size={48} />
          <p>Votre panier est vide</p>
          <p className="text-sm mt-1">Ajoutez des services pour commencer</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-2xl shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-semibold text-[#2C1810] mb-4 flex items-center gap-2">
        <ShoppingCart className="text-[#C9A96E]" size={24} />
        Votre panier ({services.length} {services.length === 1 ? 'prestation' : 'prestations'})
      </h3>

      {/* Services List */}
      <div className="space-y-3 mb-6">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-[#FDF8F3] rounded-xl p-4 group hover:shadow-md transition-all"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1">
                <h4 className="font-semibold text-[#2C1810] mb-1">
                  {service.name}
                </h4>
                <p className="text-sm text-[#5D4037] mb-2">
                  {service.category}
                </p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-[#C9A96E] font-bold">
                    {service.price}
                  </span>
                  <span className="flex items-center gap-1 text-[#A67B5B]">
                    <Clock size={14} />
                    {service.duration}
                  </span>
                </div>
              </div>
              <button
                onClick={() => onRemoveService(index)}
                className="text-red-500 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors opacity-70 group-hover:opacity-100"
                title="Retirer du panier"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Totals */}
      <div className="border-t border-[#D4C4B5] pt-4 space-y-2">
        <div className="flex items-center justify-between text-[#2C1810]">
          <span className="flex items-center gap-2">
            <Clock size={16} className="text-[#A67B5B]" />
            Durée totale
          </span>
          <span className="font-semibold">{totals.totalDuration}</span>
        </div>

        {totals.totalDurationMinutes > 360 && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">
            ⚠️ La durée totale dépasse 6 heures. Veuillez retirer des services.
          </div>
        )}

        <div className="flex items-center justify-between text-[#2C1810]">
          <span>Sous-total</span>
          <span className="font-semibold">{totals.subtotal.toFixed(2)}€</span>
        </div>

        {totals.discount > 0 && (
          <div className="flex items-center justify-between text-[#C9A96E] font-semibold bg-[#C9A96E]/10 rounded-lg p-2">
            <span className="flex items-center gap-2">
              <Tag size={16} />
              Réduction ({totals.discountPercent}%)
            </span>
            <span>-{totals.discount.toFixed(2)}€</span>
          </div>
        )}

        <div className="flex items-center justify-between text-lg font-bold text-[#2C1810] pt-2 border-t border-[#D4C4B5]">
          <span>Total</span>
          <span className="text-[#C9A96E]">{totals.totalPrice.toFixed(2)}€</span>
        </div>
      </div>

      {/* Info */}
      {totals.discount > 0 && (
        <div className="mt-4 bg-gradient-to-r from-[#C9A96E]/10 to-[#A67B5B]/10 rounded-lg p-3 text-sm text-[#2C1810]">
          <p className="font-semibold mb-1">🎉 Économisez {totals.discount.toFixed(2)}€ !</p>
          <p className="text-xs text-[#5D4037]">
            Réduction appliquée pour {services.length} prestations
          </p>
        </div>
      )}
    </div>
  );
};
